export const experience = [
  {
    id: 1,
    company: 'SwiftIQ Technologies',
    position: 'Executive Engineering Lead & Senior Software Engineer',
    period: 'March 2024 – January 2026',
    location: 'Gaborone, Botswana',
    description: [
      'Spearheaded design, development, and deployment of large-scale enterprise applications supporting secure digital services for government and private sector clients using microservices, Docker, Kubernetes, and CI/CD pipelines (GitHub Actions, GitLab CI).',
      'Architected secure, compliance-aligned applications incorporating end-to-end encryption, multifactor authentication, and audit trails in accordance with ISO 27001, OWASP, and GDPR standards.',
      'Led full SDLC lifecycle including sprint planning, release management, change control, and vendor coordination across cross-functional teams.',
      'Integrated enterprise systems using Java (Spring Boot), Node.js, Python, PostgreSQL, MongoDB, Kafka, and RESTful APIs, reducing integration latency and improving system reliability.',
    ],
  },
  {
    id: 2,
    company: 'University of Botswana',
    position: 'Computer Science Demonstrator',
    period: 'May 2025 – May 2026',
    location: 'Gaborone, Botswana',
    description: [
      'Facilitated undergraduate laboratory sessions in programming, data structures, and software engineering courses, reinforcing lecture concepts through hands-on exercises.',
      'Guided students through debugging, algorithm design, and code review, strengthening their practical software development skills.',
      'Marked assignments, practicals, and lab reports, providing constructive feedback aligned with course learning outcomes.',
      'Supported lecturers with course material preparation and provided one-on-one academic mentorship to students struggling with core concepts.',
    ],
  },
  {
    id: 3,
    company: 'Axxess Cavista',
    position: 'Senior Software Engineer',
    period: 'September 2021 – February 2024',
    location: 'Remote',
    description: [
      'Built scalable, reusable UI components using ReactJS, HTML5, CSS3, and TailwindCSS with a focus on accessibility and mobile responsiveness.',
      'Integrated RESTful and GraphQL APIs for real-time healthcare data retrieval, collaborating with product managers and QA teams in Agile sprint cycles.',
      'Conducted A/B testing and performance monitoring to continuously optimise user experience across healthcare platforms.',
    ],
  },
  {
    id: 4,
    company: 'Xavier Africa',
    position: 'Software Engineer',
    period: 'August 2020 – February 2021',
    location: 'Gaborone, Botswana',
    description: [
      'Delivered full-stack applications using ReactJS, Node.js, and Firebase, with real-time data synchronisation and secure OAuth authentication.',
      'Designed scalable data models and performed complex querying using PostgreSQL; participated in agile development cycles and client-facing project reviews.',
    ],
  },
  {
    id: 5,
    company: 'Botswana Unified Revenue Service',
    position: 'Software Engineer I',
    period: 'January 2020 – June 2020',
    location: 'Gaborone, Botswana',
    description: [
      'Contributed to development of secure Android mobile applications for internal government operations using Java and Android SDK.',
      'Implemented app-level security measures including session management and secure local data storage (SQLite); gained exposure to government-grade tax system infrastructure.',
    ],
  },
];
